import React, { useEffect, useState } from "react";
import "./TopButton.css";

export default function TopButton({ theme }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(
        document.body.scrollTop > 160 ||
          document.documentElement.scrollTop > 160
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function GoUpEvent() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return (
    <button
      type="button"
      onClick={GoUpEvent}
      id="topButton"
      className={isVisible ? "top-button-visible" : ""}
      style={{
        "--top-button-bg": theme.text,
        "--top-button-color": theme.body,
      }}
      title="Go up"
      aria-label="Scroll to top"
    >
      <i className="fas fa-arrow-up" id="arrow" aria-hidden="true" />
    </button>
  );
}
